"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      son_id: this.$route.query.son_id,
      form: {},
      form_key: {
        free_invest_device: 0,
        kc_cdb_buy_price: '',
        mc_cdb_buy_price: '',
        kc_lymmx_buy_price: '',
        mc_lymmx_buy_price: '',
        kc_mmx_buy_price: '',
        mc_mmx_buy_price: ''
      }
    };
  },
  computed: {},
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/sttuf/get_agent_buy_price', {
        son_id: this.son_id
      }).then(function (res) {
        var params = {};
        for (var i in _this.form_key) {
          params[i] = res[i];
        }
        _this.form = params;
      });
    },
    /**
     * 修改代理的采购价
     */
    editbuyprice: function editbuyprice(row) {
      var _this2 = this;
      var params = {
        son_id: this.son_id
      };
      params.free_invest_device = this.form.free_invest_device;
      params.kc_cdb_buy_price = this.form.kc_cdb_buy_price;
      params.mc_cdb_buy_price = this.form.mc_cdb_buy_price;
      params.mc_mmx_buy_price = this.form.mc_mmx_buy_price;
      params.kc_mmx_buy_price = this.form.kc_mmx_buy_price;
      params.mc_lymmx_buy_price = this.form.mc_lymmx_buy_price;
      params.kc_lymmx_buy_price = this.form.kc_lymmx_buy_price;
      this.$post('agentapi/sttuf/save_agent_buy_price', params).then(function (res) {
        _this2.$message({
          type: 'success',
          message: '设置成功'
        });
      });
    }
  }
};